import React from 'react';
import icon from '../Assets/images/icone.png';
import powered from '../Assets/images/powered.png';
import loading from '../Assets/images/loading.gif';
import Axios from 'axios'
import cep from 'cep-promise';

export default class MobileRegister extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            latitude: null,
            longitude: null,
            cep: null,
            nome: null,
            telefone: null,
            endereco: null,
            estado: null,
            cidade: null,
            bairro: null,
            cambistaCodigo: null,
            isLoading: false
        };
        console.log(window.location.href.split('/')[window.location.href.split('/').length - 1])
    }

    componentDidMount() {
        navigator.geolocation.getCurrentPosition((position) => {
            console.log(position.coords.latitude + ' ' + position.coords.longitude)
            this.setState({
              latitude : position.coords.latitude, 
              longitude: position.coords.longitude});
          });
      }

    handlerNome(event){
        this.setState({nome : event.target.value})
    }

    handlerCep(event){
        let value = event.target.value;
        if(value && isNaN(value[value.length - 1])){
            event.target.value =  value.slice(0, value.length - 1);
            this.setState({cep : event.target.value});
        }
        else{
            this.setCepMask(value)
        }
    }

    setCepMask(value){
        if(this.state.cep && value && value.length > this.state.cep.length){
            let subMask = '?????-???'
            value.split('').map((character,index) => {
                if(character != '-' && !isNaN(character)){
                    subMask = subMask.replace('?', character);
                    if(index == value.length - 1){
                      this.setState({cep : subMask.split('?')[0]});
                    }
                }
            });
        }
        else{
            this.setState({cep : value});
        }
    }

    handlerTelefone(event){
        let value = event.target.value;
        if(value && isNaN(value[value.length - 1])){
            event.target.value =  value.slice(0, value.length - 1);
        }
        else{
            this.settelefoneMask(value)
        }
    }


    settelefoneMask(value){
        if(this.state.telefone && value && value.length > this.state.telefone.length){
            let subMask = '?? ????? ????'
            value.split('').map((character,index) => {
                if(character != ' ' && !isNaN(character)){
                    subMask = subMask.replace('?', character);
                    if(index == value.length - 1){
                      this.setState({telefone : subMask.split('?')[0]});
                    }
                }
            });
        }
        else{
          
            this.setState({telefone : value});
        }
    }

    submit(){
        this.setState({isLoading: true});
        if(!this.state.nome) {
            alert("O nome de usuário deve ser preenchido!");
            this.setState({isLoading: false});
        }
        else if(!this.state.telefone) {
            alert("O telefone deve ser preenchido!");
            this.setState({isLoading: false});
        }
        else if(this.state.nome && this.state.nome.length < 6) {
            alert("Nome de usuário inválido");
            this.setState({isLoading: false});
        }
        else if(this.state.nome && !this.state.nome.includes(" ")){
             alert("Tente um nome completo!");
             this.setState({isLoading: false});
        }
        else if(this.state.telefone && this.state.telefone.length < 13){
            alert("O use um numero de telefone válido!");
            this.setState({isLoading: false});
        }
        else{
            this.registerCostumer();
        }
    }

    submitCep(){
        this.setState({isLoading: true});
        if(!this.state.cep) {
            alert("Preencha o campo de cep!");
            this.setState({isLoading: false});
        }
        else if(this.state.cep && this.state.cep.length < 9 || this.state.cep && this.state.cep.length > 9){
             alert("Cep inválido");
             this.setState({isLoading: false});
        }
        else{
            cep(this.state.cep.replace('-','')).then(res => {
                this.setState({cep: null, isLoading: false, estado: res.state , cidade: res.city, bairro: res.neighborhood, endereco: res.street + " | " + this.state.latitude + " , " + this.state.longitude })
                document.getElementById("nome").value = "";
            })
        }

    }

    async registerCostumer(){
        const hash = window.location.href.split('/')[window.location.href.split('/').length - 1];
        try {
            let sorteflash = new Axios.create({baseURL: 'https://api.cartelas.app'});
            let sortecap = new Axios.create({baseURL: 'https://api.cartelas.app'});
            let flashday = new Axios.create({baseURL: 'https://api.cartelas.app'});
            let body = {
                nome: this.state.nome , 
                telefone: this.state.telefone , 
                endereco: this.state.endereco , 
                estado: this.state.estado , 
                cidade: this.state.cidade , 
                bairro: this.state.bairro,
                cambistaCodigo: hash? hash : null
            }
            const response1 = await sorteflash.post(`/api/v1/app/auth/web`, {...body});
            const response2 = await sortecap.post(`/api/v1/app/auth/web`, {...body});
            const response3 = await flashday.post(`/api/v1/app/auth/web`, {...body});
            if(!response1 || !response2 || !response3  || response1.data.usuario || response2.data.usuario || response3.data.usuario){
                alert("Esse telefone já está cadastrado como colaborador.");
                this.setState({isLoading: false});
            }
            else{
                this.setState({isLoading: false});

                var file_path = 'https://www.sorteflash.com/download/sorteflash-app.apk';
                var a = document.createElement('A');
                a.href = file_path;
                a.download = file_path.substr(file_path.lastIndexOf('/') + 1);
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            }

            console.log(response1);
            console.log(response2);
            console.log(response3)
        } catch (error) {
            console.error(error);
        }
    }

    render() {
        return <div className="sf-container sf-center bg-gray1">
                {this.state.isLoading? 
                <div className='sf-modal'>
                    <img className='sf-loading' src={loading}></img>
                </div> : ''}
                <div className='sf-card-login bg-light'>
                    <div className='header'>
                        <img className='icone' src={icon}></img>
                    </div>
                    <div className='sf-row sf-w100 sf-mt-sm sf-center'>
                        <span className={ 'sf-title'}>Informações para caso seja contemplado!</span>
                    </div>

                    {this.state.cidade? 
                        <div className='sf-col sf-w100'>
                            <div className='sf-row sf-w100 sf-mt-sm sf-p-sm'>
                                <div className={`sf-input ${!this.state.nome? '' : 'sf-primary'}`}>
                                    <input id="nome" name="nome" maxLength={30} onChange={this.handlerNome.bind(this)} type='text'placeholder='nome de usuário'></input>
                                </div>
                            </div>
                            <div className='sf-row sf-w100 sf-mt-sm sf-p-sm'>
                                <div className={`sf-input ${!this.state.telefone? '' : 'sf-primary'}`}>
                                    <input id="telefone" name="telefone" maxLength={13} onChange={this.handlerTelefone.bind(this)} placeholder='telefone' value={this.state.telefone}></input>
                                </div>
                            </div>
                            <div className='sf-row sf-w100 sf-mt-sm sf-p-sm'>
                                <button onClick={this.submit.bind(this)} disabled={this.state.isLoading} className='w-100 sf-btn sf-primary-filed'>enviar informações</button>
                            </div>
                        </div>
                    
                    : 
                    <div className='sf-col sf-w100'>
                        <div className='sf-row sf-w100 sf-mt-sm sf-p-sm ' style={{paddingLeft: '20%', paddingRight: '20%'}}>
                            <div className={`sf-input ${!this.state.cep? '' : 'sf-primary'}`} >
                                <input  id='cep' name='cep' maxLength={9} onChange={this.handlerCep.bind(this)} type='text'placeholder='cep' value={this.state.cep}></input>
                            </div>
                        </div>
                        <div className='sf-row sf-w100 sf-mt-sm sf-p-sm'>
                            <button onClick={this.submitCep.bind(this)} disabled={this.state.isLoading} className='w-100 sf-btn sf-primary-filed'>confirmar</button>
                        </div>
                    </div>
                    
                    }

                    <div className='sf-row h-100 w-100 sf-center'>
                        <img className='powered' src={powered}></img>
                    </div>
                </div>
        </div>
    }
}